import { DateTime, Duration } from 'luxon';

import { DateFilterOptionType } from '../../models';

export function deductDaysFilter(dateFilterOption: DateFilterOptionType) {
  return {
    [DateFilterOptionType.Last7Days]: deductCurrentDateWithNDays(7),
    [DateFilterOptionType.Last30Days]: deductCurrentDateWithNDays(30),
    [DateFilterOptionType.Last90Days]: deductCurrentDateWithNDays(90),
  }[dateFilterOption];
}

export function deductCurrentDateWithNDays(days: number) {
  const from = DateTime.utc().minus(Duration.fromObject({ days }));
  const to = DateTime.utc();

  return {
    from: from.toISO(),
    to: to.toISO(),
  };
}
